export default "__VITE_ASSET__QWLHdbkN__"